import { render, staticRenderFns } from "./ReportesSerieActivaPantalla.vue?vue&type=template&id=047b4b78&"
import script from "./ReportesSerieActivaPantalla.vue?vue&type=script&lang=ts&"
export * from "./ReportesSerieActivaPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('047b4b78', component.options)
    } else {
      api.reload('047b4b78', component.options)
    }
    module.hot.accept("./ReportesSerieActivaPantalla.vue?vue&type=template&id=047b4b78&", function () {
      api.rerender('047b4b78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ReportesSerieActiva/ReportesSerieActivaPantalla.vue"
export default component.exports